import { useState } from "react";
import QRCode from "qrcode";
import { saveAs } from "file-saver";
import { connect } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import { StickerQrCode } from "sticker_templates";
import { downloadGdnLabel } from "actions/pack_gdn";

const getProductLocationIdentifier = (product) =>
  product?.product_main_locations?.find(({ warehouse_id }) => warehouse_id === 2)
    ?.warehouse_position?.identifier;

const QrCodesInfo = ({ expano_oms_id, gdn_id, current_user, gdn_lines }) => {
  const [qenerating_ids, setGeneratingIds] = useState([]);

  const gdn_lines_code_problem = gdn_lines?.filter(
    ({ status, problem_with_code_reported_at }) => status === 'picked' && !!problem_with_code_reported_at
  );

  if (!gdn_lines_code_problem?.length) {
    return null;
  }

  const handleGenerateQr = async ({
    id,
    sku,
    name,
    quantity,
    product_location_identifier,
  }) => {
    try {
      const qr_code_base64 = await QRCode.toDataURL(sku);
      setGeneratingIds([...qenerating_ids, id]);
      const blob = await pdf(
        <StickerQrCode
          data={[
            {
              sku,
              name,
              quantity,
              product_location_identifier,
              qr_code_base64,
            },
          ]}
        />
      ).toBlob();
      saveAs(blob, `${sku}-qr.pdf`);
    } catch (error) {
      console.log(error);
    } finally {
      setGeneratingIds(qenerating_ids.filter((item) => item.id !== id));
    }
  };

  return (
    <div className="package-info-panel">
      <div className="package-info-panel__warnings">
        <h3>Problemy z kodem</h3>
        {gdn_lines_code_problem.map(({ id, product, quantity }) => {
          const is_generating = qenerating_ids.includes(id);
          const product_location_identifier =
            getProductLocationIdentifier(product);
          return (
            <p>
              <strong className="m-r-10">{product.sku}</strong>
              {product.name}
              {["admin", "manager"].includes(current_user?.role) && (
                <>
                  {!!product_location_identifier ? (
                    <button
                      disabled={is_generating}
                      type="button"
                      className="btn btn-sm btn-info m-l-10"
                      onClick={() =>
                        handleGenerateQr({
                          id,
                          sku: product.sku,
                          name: product.name,
                          quantity,
                          product_location_identifier,
                        })
                      }
                    >
                      {is_generating ? (
                        <span>Proszę czekać...</span>
                      ) : (
                        <span>
                          Generuj QR ( {Number(quantity).toFixed(0)}x )
                        </span>
                      )}
                    </button>
                  ) : (
                    <span className="m-l-10 text-underline">
                      Brak identyfikatora lokalizacji na magazynie wysyłkowym
                    </span>
                  )}
                </>
              )}
            </p>
          );
        })}
        {["admin", "manager"].includes(current_user?.role) && (
          <p className="m-t-20">
            <button
              type="button"
              disabled={qenerating_ids.length > 0}
              className="btn btn-sm btn-info"
              onClick={() =>
                gdn_lines_code_problem.forEach(({ id, product, quantity }) => {
                  const product_location_identifier =
                    getProductLocationIdentifier(product);
                  if (product_location_identifier) {
                    handleGenerateQr({
                      id,
                      sku: product.sku,
                      name: product.name,
                      quantity,
                      product_location_identifier,
                    });
                  }
                })
              }
            >
              <span>
                {qenerating_ids.length > 0
                  ? "Proszę czekać..."
                  : "Generuj wszystkie QR"}
              </span>
            </button>
          </p>
        )}
        <p className="m-t-20">
          <button
            type="button"
            className="btn btn-sm btn-info"
            onClick={() =>
              downloadGdnLabel({
                expano_oms_id,
                id: gdn_id,
                user_name: current_user.full_name,
              })
            }
          >
            <span>Wygeneruj kod QR zamówienia</span>
          </button>
        </p>
      </div>
    </div>
  );
};

export default connect(
  ({
    current_user,
    pack_gdn: {
      data: { gdn_lines, expano_oms_id, id },
    },
  }) => ({
    current_user,
    gdn_lines,
    expano_oms_id,
    gdn_id: id,
  })
)(QrCodesInfo);
